import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import * as Actions from 'actions';
import * as Api from '@hailtrace/client-api';
import initSwathOpacitySlider from './utils/initSwathOpacitySlider';
import classNames from 'classnames';
import moment from 'moment';
import { markMapAsUnFinished, notify } from 'api';
import {
  KmlLayer,
  Map,
  DataLayer,
  Feature,
  SearchBox,
  Marker
} from 'google-react-maps';
import {
  Container,
  DisconnectedErrorModal,
  CreateMapModal,
  DeleteMapModal,
  EditMapModal,
  MapEditWarningModal,
  MapCreatorSidebar,
  MapCreatorPlaces,
  MapCreatorKMLLayers,
  MapCreatorDataLayer,
} from 'components';

const copy = d => JSON.parse(JSON.stringify(d));
class MapCreator extends React.Component {
  constructor(props) {
    super(props);
    this.handleZoomChanged = this.handleZoomChanged.bind(this);
    this.handleCenterChanged = this.handleCenterChanged.bind(this);
    this.handlePlacesChanged = this.handlePlacesChanged.bind(this);

    this.displayName = 'MapCreator';
    this.zoom = Number(localStorage.getItem('mapEditor:zoom'));
    this.center = JSON.parse(localStorage.getItem('mapEditor:center') || 'null');
    this.state = {};
  }

  handleCenterChanged(center) {
    if(!localStorage || !center) {
      return;
    }
    localStorage.setItem('mapEditor:center', JSON.stringify(center));
    this.center = center;
  }
  handleZoomChanged(zoom) {
    if(!localStorage || !zoom) {
      return;
    }
    localStorage.setItem('mapEditor:zoom', `${zoom.toString()}`);
    this.zoom = zoom;
  }
  handlePlacesChanged(updated_places) {
    const { places: current_places } = this.props.mapCreator;
    if(updated_places.length == 1) {
      if(this.map) {
        if(!(current_places || []).find(place => place.id == updated_places[0].id)) {
          this.map.setZoom(10);
          this.map.setCenter(updated_places[0].geometry.location);
        }
      }
      this.props.handleMapCreatorPlacesChange(updated_places);
    }
    else {
      this.props.handleMapCreatorPlacesChange([]);
    }
  }
  componentWillMount() {
    if(!this.props.hasPermission('/Maps/Create/')) {
      this.context.router.goBack();
    }
    this.props.initMapCreator();
  }
  componentDidMount() {
    initSwathOpacitySlider.call(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if(
      prevProps.socket.connected === true &&
      this.props.socket.connected === false
    ) {
      this.props.toggleShowDisconnectedSocketError(true);
    }

    // TODO : Change mouse cursor when placing markers
    // const { drawing_mode: curr_drawing_mode, current_marker_type } = this.props.mapCreator;
    // if(
    //   prevProps.mapCreator.drawing_mode != curr_drawing_mode &&
    //   curr_drawing_mode == 'Point' &&
    //   current_marker_type != null
    // ) {
    //   console.log('hit');
    //   $('.inner-body').css({ cursor: 'pointer' });
    // }
  }

  render() {
    const SearchControlWrapper = ({ children }) => (
      <div style={{maxWidth:'300px',width:'100%'}} className='mb-sm'>
        <div className='input-group'>
          <span className='input-group-addon'><i className='wi-compass'></i> </span>{children}
        </div>
      </div>
    );

    const SearchControl = (
      <SearchBox
        ref='searchBox'
        placeholder='Enter a place name, address, or type'
        onPlacesChanged={this.handlePlacesChanged}
        wrapper={SearchControlWrapper}
        className='form-control'
        position='TOP_RIGHT'
      />
    );

    const {
      current_map,
      current_feature,
      maps_list,
      hidden_maps,
      hidden_kml_layers,
      hidden_features,
      drawing_mode,
      swath_opacity,
      show_disconnected_socket_error,
      places: current_places
     } = this.props.mapCreator;

    return (
      <Container title='Map Creator'>
        <section className='content-with-menu'>
          <div className='content-with-menu-container'>
            <div className='inner-menu-toggle'>
              <a
                onClick={(e) => $('html').addClass('inner-menu-opened')}
                className='inner-menu-expand'
                data-open='inner-menu'
                >
                Show Options <i className='fa fa-chevron-right' />
              </a>
            </div>
            <MapCreatorSidebar />
            <div className='inner-body'>
              <Map
                onMount={(map, maps) => {
                  this.map = map;
                  this.maps = maps;
                }}
                style={{ top: 0, bottom: 0, left: 0, right: 0, position: 'absolute'}}
                api-key='AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw'
                onCenter_Changed={this.handleCenterChanged}
                onZoom_Changed={this.handleZoomChanged}
                center={this.center}
                zoom={this.zoom}
                controls={[ SearchControl ]}
                >
                <MapCreatorPlaces
                  map={this.map}
                  maps={this.maps}
                />
                <MapCreatorKMLLayers
                  map={this.map}
                  maps={this.maps}
                />
                <MapCreatorDataLayer
                  map={this.map}
                  maps={this.maps}
                />
              </Map>
              {this.props.children}
            </div>
          </div>
        </section>

        <CreateMapModal />
        <DeleteMapModal />
        <EditMapModal />
        <MapEditWarningModal />
        <DisconnectedErrorModal show_condition={show_disconnected_socket_error} />
    	</Container>
    );
  }
}

MapCreator.contextTypes = {
  router : PropTypes.object
}


export default mapCreatorConnect(MapCreator);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator.js